import TextEllipsis from 'Components/TextEllipsis';
import { useSelectProductAvailableTimes } from 'core/hooks';
import {
  IProduct,
  IProductMenuDisplay,
} from 'core/redux/features/products/types';
import { width } from 'dom-helpers';
import React, { useEffect, useRef, useState } from 'react';
import PlainMenuList from './PlainMenusList';
import { ProductTimeList } from './ProductTimes';

const __maxWidthPerTimeItemMobile = 33.84;
const __maxWidthPerTimeItemDesktop = 42;

const __maxWidthPerTimeItemMobileWithEndTime = 72;
const __maxWidthPerTimeItemDesktopWithEndTime = 82;

export const CardFooter = ({
  menus,
  product,
  hideDescription,
  deviceType,
}: {
  product: IProduct;
  menus: IProductMenuDisplay[];
  hideDescription?: boolean;
  deviceType?: string;
}) => {
  const footerRef = useRef(null);
  const [footerSize, setFooterSize] = useState(0);
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (window !== undefined) {
      setTimeout(() => {
        if (!footerRef.current) {
          return;
        }

        const footerWidth = width(footerRef.current) - 32;

        if (footerSize !== footerWidth) {
          setFooterSize(footerWidth);
        }
      }, 500);
    }
    // eslint-disable-next-line
  }, []);

  const availableTime = useSelectProductAvailableTimes(product);
  const timeLength = availableTime.length >= 5 ? 5 : availableTime.length;

  let defaultWidth;
  if (product.product_type === 'bar') {
    defaultWidth =
      deviceType === 'mobile'
        ? __maxWidthPerTimeItemMobileWithEndTime
        : __maxWidthPerTimeItemDesktopWithEndTime;
  } else {
    defaultWidth =
      deviceType === 'mobile'
        ? __maxWidthPerTimeItemMobile
        : __maxWidthPerTimeItemDesktop;
  }
  const widthPerItem = defaultWidth * timeLength;

  const productDesc = product?.mobile_description ?? product.short_description;
  return (
    <footer className="product-card__footer" ref={footerRef}>
      {hideDescription !== true ? (
        <div className="_item _12">
          <TextEllipsis observe={false} clump={2} className="desc">
            {productDesc}
          </TextEllipsis>
        </div>
      ) : null}
      <div className="product-card__grid">
        <div>
          <ProductTimeList
            style={{ width: `${widthPerItem}px` }}
            separator={<span className="time-separator">, </span>}
            label={false}
            className="time"
            product={product}
          />
        </div>
        <div
          className="menus"
          style={{
            width: `${footerSize - widthPerItem}px`,
            overflow: 'hidden',
          }}
        >
          <PlainMenuList menuPreviews={menus} />
        </div>
      </div>
    </footer>
  );
};

export default CardFooter;
